export enum StatisticFilterCompareTypeEnum {
    PlanFact,
    OtherTradePoints,
    MonthPrev,
    MonthPrevByDays,
    MonthPrevYear,
    MonthPrevAverage,
    YearPrev,
    YearPrevByDays,
    DayPrevWeek,
    DayPrevMonthAverage,
    DayPrevYear,
    OtherDatePeriod,
}
